import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class ExtractedUserSpecificBeneficiaryMeta extends BaseEntityModel {
  parentId?: string;
  specificGiftName?: string;
  specificGiftShare?: number;
  specificMonetaryGift?: number;

  constructor(model: Partial<ExtractedUserSpecificBeneficiaryMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.specificGiftName = model.specificGiftName;
    this.specificGiftShare = model.specificGiftShare;
    this.specificMonetaryGift = model.specificMonetaryGift;
  }

  get displayGift(): string {
    // If there's no specific gift name or monetary gift, return an empty string.
    if (!this.specificGiftName && !this.specificMonetaryGift) {
      return '';
    }

    // If there is a specific gift name but no share or monetary value, return just the name.
    if (this.specificGiftName && !this.specificGiftShare && !this.specificMonetaryGift) {
      return this.specificGiftName;
    }

    // If there's a specific gift name and share is 100%, return the name and monetary value if present.
    if (this.specificGiftName && this.specificGiftShare === 100) {
      return this.specificMonetaryGift
        ? `${this.specificGiftName}; $${this.specificMonetaryGift}`
        : this.specificGiftName;
    }

    if (!this.specificGiftShare) {
      return '';
    }

    // Build the gift string when there's a gift name and either share or monetary value.
    let giftString: string = this.specificGiftName
      ? `${this.specificGiftShare}% of ${this.specificGiftName}`
      : '';
    if (this.specificMonetaryGift) {
      giftString += (giftString ? '; ' : '') + `$${this.specificMonetaryGift}`;
    }

    return giftString;
  }
}
